<footer [ngClass]="state=='open' ? 'footer_open' : ''" class="footer">
  <div style="padding: 0 20px;
  line-height: 50px;">
    <div class="pull-left">
      © Copyright <span class="current-year">{{ currentYear }}</span>
      <span class="text-bold text-uppercase"> Chatstasy, LLC</span>.
      <span>All rights reserved</span>
    </div>
    <div class="pull-right">
      <span class="go-top"><i class="ti-angle-up"></i></span>
    </div>
  </div>
</footer>